/*
Swym data sample.
empi: product ID
epi: variant ID
[
    {
        "di": "2777b1e9-2bd2-470f-aae0-f911f42cb709",
        "bt": "ASTR the Label",
        "uid": "EnRHzXIlmTbqkz3n3x+xhujiy62oOoCrVDZUf4irdg8=",
        "dt": "Blythe Floral Plisse Midi Dress",
        "et": 4,
        "cts": 1783706161031,
        "source": "unknown",
        "empi": 6678899556528,
        "sku": "ACDR100873-CORAL MULTI-XS",
        "cby": "Alex",
        "lid": "d9f0d69a-4769-46de-97ef-8345384788b7",
        "du": "https://www.astrthelabel.com/products/blythe-floral-plisse-midi-dress?variant=39807769837744",
        "pid": "p34gnYsg8cRqR2GHg97SrAj5gqwaQOKWvehbky/N4rw=",
        "epi": 39807769837744,
        "id": "0d4664ce-2a78-4787-95de-0d933d128cae",
        "uts": 1783706161031,
        "_pkey": "EnRHzXIl",
        "hashtags": [],
        "iu": "https://cdn.shopify.com/s/files/1/2483/6632/files/ACDR100873_CORALMULTI_0624_620x620.jpg?v=1774896389",
        "_t": 2,
        "uby": "Alex",
        "pr": 164,
        "vi": "CORAL MULTI/XS"
    },
    ...
]
*/
import OpenCloseQuicklook from '../../components/quicklook/openCloseQuicklook';

let instance = null;

// Collection page / Search overlay and anything using the product tiles with the wishlist
export default class ProductTilesWishlist {
  constructor() {
    if (instance) {
      return instance;
    }

    instance = this;
    this.swymCallbackRegistered = false;
    this.init();
    this.OpenCloseQuicklookInstance = new OpenCloseQuicklook('wishlist');
  }

  init() {
    document.addEventListener('astr-plp-tiles-built', (e) => {
      console.log('[ASTR] astr-plp-tiles-built event', e.data);
      this.fetch();
    });

    const handleWishlistTileInteraction = (e, source = 'click') => {
      const button = e.target.closest('[data-product-wishlist]');
      if (!button) return;

      // On mobile, touchend is followed by click. Ignore the follow-up click.
      if (source === 'click') {
        const lastTouchTs = Number(button.dataset.lastTouchTs || 0);
        if (lastTouchTs && Date.now() - lastTouchTs < 700) {
          return;
        }
      }

      if (source === 'touchend') {
        button.dataset.lastTouchTs = String(Date.now());
      }

      if (button.hasAttribute('data-open-signin-actions-modal')) {
        // Mobile can suppress the follow-up click after touchend.
        // Trigger a synthetic click so the delegated sign-in modal handler runs.
        if (source === 'touchend') {
          e.preventDefault();
          e.stopPropagation();
          button.click();
        }
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      this.openAddToWishlistModal(button);
    };

    document.addEventListener('click', (e) => {
      handleWishlistTileInteraction(e, 'click');
    });

    document.addEventListener('touchend', (e) => {
      handleWishlistTileInteraction(e, 'touchend');
    });

    // Attempt initial load
    this.fetch();
  }

  fetch = () => {
    if (window.wishlist_products) {
      this.updateIcons();
      return;
    }

    if (window._swat) {
      window._swat.fetch((wishlistProducts) => {
        // console.log('wishlistProducts', wishlistProducts);
        window.wishlist_products = wishlistProducts;

        if (wishlistProducts.length <= 0) {
          return;
        }

        this.updateIcons();
      }, window._swat.EventTypes.addToWishList);
    } else if (!this.swymCallbackRegistered) {
      this.swymCallbackRegistered = true;
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(() => {
        this.swymCallbackRegistered = false;
        this.fetch();
      });
    }
  };

  updateIcons = () => {
    if (!window.wishlist_products || window.wishlist_products.length <= 0) {
      return;
    }

    // Initialize wishlist within product tiles
    const allTilesIcons = document.querySelectorAll('.product-tile [data-product-wishlist][data-is-init="false"]');

    for (const tileIcon of allTilesIcons) {
      const productId = Number(tileIcon.dataset.productId);
      tileIcon.dataset.isInit = 'true';

      if (window.wishlist_products.some(product => product.empi === Number(productId))) {
        tileIcon.classList.add('active');
      } else {
        tileIcon.classList.remove('active');
      }
    }
  };

  openAddToWishlistModal = (button) => {
    console.log('openAddToWishlistModal', button);
    const product_tile = button.closest('.product-tile');
    if (!product_tile) return;

    const product_id = button.dataset.productId;

    const colorSwatches = product_tile.querySelectorAll('.color-swatch');

    let selected_color_swatch = product_tile.querySelector('.color-swatch.active');
    if (!selected_color_swatch && colorSwatches.length > 0) {
      selected_color_swatch = colorSwatches[0];
    }

    // if (!selected_color_swatch) return;

    const color_name = selected_color_swatch ? selected_color_swatch.dataset.colorValue : '';
    const variant_id = selected_color_swatch ? selected_color_swatch.dataset.variantId : button.dataset.variantId;

    if (!variant_id) return;

    const selected_size = '';
    const is_cart_edit = false;
    const is_wishlist = true;
    const ratingData = {
      reviews_average: product_tile.dataset.ratingAverage || '0',
      review_count: product_tile.dataset.ratingCount || '0'
    };

    if (window.theme.breakpoints.current === 'mobile') {
      this.OpenCloseQuicklookInstance.openQuicklookMobile(product_id, color_name, selected_size, is_cart_edit, null, variant_id, ratingData, is_wishlist);
    } else {
      this.OpenCloseQuicklookInstance.openQuicklookDesktop(product_id, color_name, selected_size, is_cart_edit, variant_id, ratingData, is_wishlist);
    }
  };
}
